<template>
	<div>
		<div class="search flex">
			<span class="tit">
				结账单管理
				<i class="el-icon-setting rule-setting" @click="ruleDrawer.show=true">结算规则管理</i>
			</span>
      <el-date-picker style="border-color: #567CFF"
                      v-model="search.dateRange"
                      type="daterange"
                      @change="skipPage(1)"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
      </el-date-picker>
			<el-input placeholder="结账单号/订单号/医生名字"
								class="addART"
								v-model="search.keyword"
								suffix-icon="el-icon-search"
								size="small"
                style="width: 280px"
								@change="skipPage(1)">
			</el-input>
		</div>

		<div class="instrument" style="margin-top: 0">
      <div style="text-align: right;color: #FC7C66">
        <span style="display: inline-block;width: 280px">订单总金额: {{statistics.total/100}} 元</span>
        <span style="display: inline-block;width: 280px">实际支付金额: {{statistics.actual/100}} 元</span>
        <span style="display: inline-block;width: 280px">已结算金额: {{statistics.settled/100}} 元</span>
      </div>
			<el-table
					:data="page.rows"
					class="record-table"
					:header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
					height="calc(100vh - 292px)"
					style="width: 100%;font-size:14px;color:#333;font-weight:400;margin-bottom: 10px;"
					max-height="calc(100vh - 292px)">
				<el-table-column prop="billNo" label="结账单号" align="center" width="150"></el-table-column>
				<el-table-column prop="orderNo" label="订单号" align="center" width="150">
					<template slot-scope="scope">
						<a href="javascript:void(0)" style="color: cornflowerblue" @click="orderDetails(scope.row)">{{scope.row.orderNo}}</a>
					</template>
				</el-table-column>
        <el-table-column label="医生" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.doctorFullName || scope.row.doctorEnName}}</span>
          </template>
        </el-table-column>
				<el-table-column prop="billTimestamp" align="center" label="账单时间">
					<template slot-scope="scope">{{new Date(scope.row.billTimestamp).Format('yyyy-MM-dd HH:mm:ss')}}</template>
				</el-table-column>
				<el-table-column label="结账类型" align="center" width="100">
					<template slot-scope="scope">{{BILL_TYPES[scope.row.billType]}}</template>
				</el-table-column>
				<el-table-column label="结账状态" align="center" width="100">
					<template slot-scope="scope">{{BILL_STATUS[scope.row.billStatus]}}</template>
				</el-table-column>
				<el-table-column label="订单金额" align="center" width="120">
					<template slot-scope="scope">
						<span>{{(scope.row.orderTotalAmount/100).toFixed(2)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="实际支付" align="center" width="120">
					<template slot-scope="scope">
						<span>{{(scope.row.orderActualAmount/100).toFixed(2)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="已结金额" align="center" width="120">
					<template slot-scope="scope">
						<span>{{(scope.row.settledAmount/100).toFixed(2)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="160">
					<template slot-scope="scope">
						<el-button size="mini" type="text" class="btn" @click="openSettlementItemDrawer(scope.row)">结算</el-button>
						<el-button size="mini" type="text" class="btn" @click="billDetails(scope.row)">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
					:hide-on-single-page="true"
					class="pagination"
					background
					prev-text="Prev"
					next-text="Next"
					@current-change="skipPage"
					:current-page="page.current"
					:page-size="page.size"
					layout="prev, pager, next"
					:total="page.total">
			</el-pagination>

		</div>
		
		<!-- 结算规则 -->
		<el-drawer title="结算规则管理" size="800px" class="drawerCommon"
							 :wrapperClosable="false"
							 :show-close="false"
							 @opened="handleRuleDrawerOpened"
							 :visible.sync="ruleDrawer.show">
			<el-table ref="settledRuleTable"
								:header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
								height="calc(100vh - 180px)" class="record-table"
								max-height="calc(100vh - 180px)"
								:data="ruleDrawer.rules">
				<el-table-column label="规则名称" prop="ruleTitle" align="center"></el-table-column>
				<el-table-column label="状态" align="center" width="60">
					<template slot-scope="scope">
						<span :state="scope.row.ruleStatus" @click="changeRuleStatus(scope.row)">{{scope.row.ruleStatus==0?'关闭':(scope.row.ruleStatus==1?'开启':'-')}}</span>
					</template>
				</el-table-column>
				<el-table-column label="结算比例" align="center" width="80">
					<template slot-scope="scope">{{scope.row.settleRate}}%</template>
				</el-table-column>
				<el-table-column label="备注" prop="remark" align="center"></el-table-column>
				<el-table-column label="操作" align="center" width="80">
					<template slot-scope="scope">
						<el-button size="mini" type="text" class="btn" @click="delSettleRule(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
			<div class="footer">
				<el-button style="width: 90px;" size="small" type="primary" @click="openAddRuleDialog">新增规则</el-button>
				<el-button style="width: 90px;margin-left: 20px" size="small" @click="ruleDrawer.show=false">取消</el-button>
			</div>
		</el-drawer>
		
		<!-- 新增结算规则弹窗 -->
		<el-dialog :visible="addRuleDialog.show"
							 title="新增结算规则"
							 width="600px"
							 append-to-body
							 :show-close="false">
			<div style="padding-right: 80px">
				<el-form ref="addRuleForm" :model="addRuleDialog.form" label-width="90px">
					<el-form-item label="规则名称">
						<el-input v-model="addRuleDialog.form.ruleTitle" minlength="2" maxlength="30" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="状态">
						<el-radio-group v-model="addRuleDialog.form.ruleStatus">
							<el-radio :label="1">启用</el-radio>
							<el-radio :label="0">关闭</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="结算比例">
						<el-slider v-model="addRuleDialog.form.settleRate" :min="1" :max="100" style="width: 80%;display: inline-block;"></el-slider>
						<span class="slider-tips">{{addRuleDialog.form.settleRate}}%</span>
					</el-form-item>
					<el-form-item label="备注">
						<el-input type="textarea" :rows="3" v-model="addRuleDialog.form.remark" maxlength="200" show-word-limit></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="doAddSettleRule" :loading="addRuleDialog.btnLoad">新增</el-button>
				<el-button @click="addRuleDialog.show=false">取消</el-button>
			</div>
		</el-dialog>
		
		<!-- 已结算列表 -->
		<el-drawer title="已结算列表" size="800px" class="drawerCommon"
							 :wrapperClosable="false"
							 :show-close="false"
							 :visible.sync="settlementItemDrawer.show"
							 @opened="handleSettlementItemDrawerOpened">
			<el-table ref="settledItemTable"
								:header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
								height="calc(100vh - 180px)" class="record-table"
								max-height="calc(100vh - 180px)"
								:data="settlementItemDrawer.items">
				<el-table-column label="结算时间">
					<template slot-scope="scope">{{new Date(scope.row.settleTimestamp).Format('yyyy-MM-dd HH:mm')}}</template>
				</el-table-column>
				<el-table-column label="结算金额" align="center" width="120">
					<template slot-scope="scope">
						<span>{{(scope.row.settleAmount/100).toFixed(2)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="凭证" prop="voucher" align="center"></el-table-column>
				<el-table-column label="备注" prop="remark" align="center"></el-table-column>
			</el-table>
			<div class="footer">
				<el-button style="width: 90px;" size="small" type="primary" @click="openSettlementDialog">新增结算</el-button>
				<el-button style="width: 90px;margin-left: 20px" size="small" @click="settlementItemDrawer.show=false">取消</el-button>
			</div>
		</el-drawer>
		
		
		<!-- 新增结算弹窗 -->
		<el-dialog title="新增结算"
               width="600px"
               top="0"
							 :visible.sync="settlementItemDialog.show">
			
			<div style="padding-right: 80px">
				<el-form label-width="120px">

          <el-form-item label="结算规则" v-if="settlementItemDrawer.items.length==0">
            <el-radio-group  v-model="settlementItemDialog.form.ruleId">
              <el-radio v-for="rule in settlementRules" :label="rule.id" :key="rule.id">
                {{rule.ruleTitle}}
                <el-tooltip :content="rule.remark">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-radio>
            </el-radio-group>
          </el-form-item>
					<el-form-item label="本次结算金额">
						<el-input type="number" v-model="settlementItemDialog.form.settleAmount" min="0" style="width: 160px">
              <span slot="suffix" style="margin-right: 4px;">元</span>
            </el-input>
					</el-form-item>
          <el-form-item label="结算凭证">
            <el-input v-model="settlementItemDialog.form.voucher"></el-input>
          </el-form-item>
          <el-form-item label="是否校验姓名">
            <el-switch
                v-model="settlementItemDialog.form.checkName"
                active-color="#13CE66"
                inactive-color="#AAA">
            </el-switch>
          </el-form-item>
          <el-form-item label="医生真实姓名" v-if="settlementItemDialog.form.checkName">
            <el-input v-model="settlementItemDialog.form.doctorRealName"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="4" v-model="settlementItemDialog.form.remark"></el-input>
          </el-form-item>
				</el-form>
			</div>
			<div slot="footer">
        <el-button style="width: 90px;" size="small" type="primary" :loading="settlementItemDialog.btnLoad" @click="doSettled">结算</el-button>
        <el-button style="width: 90px;margin-left: 20px" size="small" @click="settlementItemDialog.show=false">取消</el-button>
      </div>
		</el-dialog>
		
		
		
	</div>
</template>

<script>
import base from "../../../api/common";
export default {
	name: "settlementBillList",
	data() {
		return {
      BILL_TYPES:['-','预约单','月卡','年卡','测试单'],
      BILL_STATUS:['未结算','部分结算','已结清'],
      settlementRules:[], // 结算规则
			search:{
				keyword:'',
        dateRange:[],
			},
			page:{
			  current: 1,
				size: 10,
				total: 8,
				rows:[]
			},
      statistics:{
        total: 0,
        actual: 0,
        settled: 0
      },
      settlementItemDrawer:{
        show : false,
        settlement: {},
				items:[]
			},
      settlementItemDialog:{
        show: false,
        btnLoad: false,
				form:{
          ruleId: '',
          settleAmount: 0,
          voucher: '',
          checkName: true,
          doctorRealName:'',
          remark: ''
				}
			},
			ruleDrawer:{ // 结算规则drawer
        show: false,
				rules:[],
			},
      addRuleDialog:{ // 新增规则dialog
        show: false,
				btnLoad: false,
				form:{
          ruleTitle: '',
					ruleStatus: 1,
					settleRate: 70,
					remark: ''
				}
			}
			
		}
	},
  inject: ['reload'],
	mounted() {
	  // 加载结算规则
		this.$ajax.post(base.basePath + 'financial/settlement-rule/admin/list/in-use').then(res=>{
		  if(res.data.status === 'success'){
		    this.settlementRules = res.data.list;
			}else{
		    this.$message.error('结算规则加载失败!');
			}
		}).catch(err=>{
		  console.error(err);
      this.$message.error('结算规则加载失败!');
		});
	  // 默认时间跨度为当月
    let todayTimestamp = new Date();
    let monthFirstDay = new Date().setDate(1);
    this.search.dateRange.push(monthFirstDay,todayTimestamp)
	  this.skipPage(1);
	},
	methods: {
		getData(){
			let that = this;
			let params = {
        page: that.page.current,
        size: that.page.size,
        keyword: that.search.keyword,
      };
			if(that.search.dateRange.length === 2){
        params.beginTimestamp = new Date(that.search.dateRange[0]).getTime();
        params.endTimestamp = new Date(that.search.dateRange[1]).setHours(23,59,59,999);
      }

      that.$ajax.post(base.basePath + 'financial/settlement-bill/admin/page',params).then(res=>{
			  if(res.data.status === 'success'){
			    that.page.current = res.data.current;
			    that.page.size = res.data.size;
			    that.page.total = res.data.total;
			    that.page.rows = res.data.rows;
				}else{
			    that.$message.error(res.data.message);
				}
			}).catch(err=>{
			  console.error(err);
			  that.$message.error('数据加载失败')
			})
		},
		skipPage(current){
		  let that = this;
 			this.page.current = current;
 			this.getData();

      if(current != 1){return;}
 			// 统计金额数据
      let params = {
        page: that.page.current,
        size: that.page.size,
        keyword: that.search.keyword,
      };
      if(that.search.dateRange.length === 2){
        params.beginTimestamp = new Date(that.search.dateRange[0]).getTime();
        params.endTimestamp = new Date(that.search.dateRange[1]).setHours(23,59,59,999);
      }

      this.$ajax.post(base.basePath + 'financial/settlement-bill/admin/statistics', params).then(res=>{
        if(res.data.status === 'success'){
          that.statistics.total = res.data.data.total;
          that.statistics.actual = res.data.data.actual;
          that.statistics.settled = res.data.data.settled;
        }
      }).catch(err=>{
        console.error(err);
        that.$message.error('');
      });
		},
    billDetails(item){
		  console.log(item);
		},
    orderDetails(item){
		  console.log(item);
		},
    openSettlementItemDrawer(item){
		  this.settlementItemDrawer.show = true;
		  this.settlementItemDrawer.settlement = item;
		},
    handleSettlementItemDrawerOpened(){
      let that = this;
      let id = that.settlementItemDrawer.settlement.id;
      if(!id){return;}
      that.$ajax.get(base.basePath + 'financial/settlement-bill-item/admin/list/' + id).then(res=>{
        if(res.data.status === 'success'){
          that.settlementItemDrawer.items = res.data.list;
				}else{
          that.$message.error('数据加载失败');
				}
			}).catch(err=>{
			  console.error(err);
			  that.$message.error('数据加载失败');
			})
    },
    openSettlementDialog(){ // 新增结算
			let that = this;
			if(that.settlementItemDrawer.settlement.billStatus == 2){
			  that.$message.warning('账单已结清, 无需结算.');
          return;
      }

			that.settlementItemDialog.show = true;
			// 重置数据
      that.settlementItemDialog.form.ruleId = '';
      that.settlementItemDialog.form.settleAmount = 0;
      that.settlementItemDialog.form.voucher = '';
      that.settlementItemDialog.form.checkName = true;
      that.settlementItemDialog.form.doctorRealName ='';
      that.settlementItemDialog.form.remark = '';
		},
    handleRuleDrawerOpened(){
		  this.ruleDrawer.rules.length = 0;
			this.$ajax.post(base.basePath + 'financial/settlement-rule/admin/list/all').then(res=>{
			  if(res.data.status === 'success'){
          this.ruleDrawer.rules = res.data.list;
				}else{
			    this.$message.error(res.data.message);
				}
			}).catch(err=>{
			  console.error(err);
			  this.$message.error('结算规则数据加载失败');
			})
    },
    openAddRuleDialog(){
		  this.addRuleDialog.show = true;
		  this.addRuleDialog.form.ruleTitle = '';
		  this.addRuleDialog.form.ruleStatus = 1;
		  this.addRuleDialog.form.settleRate = 70;
		  this.addRuleDialog.form.remark = '';
		},
    doAddSettleRule(){
		  console.log(this.addRuleDialog.form);
		  let that = this;
		  if($.trim(that.addRuleDialog.form.ruleTitle).length == 0){that.$message.warning('规则名称不能为空'); return;}
		  that.addRuleDialog.btnLoad = true;
		  that.$ajax.post(base.basePath + 'financial/settlement-rule/admin/add',that.addRuleDialog.form).then(res=>{
		    if(res.data.status === 'success'){
		      that.$message.success('新增成功');
		      setTimeout(()=>{that.reload()},1666);
				}else{
		      that.$message.error(res.data.message);
          that.addRuleDialog.btnLoad = false;
				}
			}).catch(err=>{
			  console.error(err);
			  that.$message.error('操作失败');
        that.addRuleDialog.btnLoad = false;
			})
		},
    changeRuleStatus(item){
		  let that = this;
      let targetStatus = (item.ruleStatus + 1)%2;
		  that.$messageBox.confirm('确定要' + (item.ruleStatus == 1?'关闭':'开启') + '吗?','状态更改确认', {type:'warning'}).then(()=>{
          that.$ajax.post(base.basePath + 'financial/settlement-rule/admin/update/status/' + targetStatus +  '/' + item.id).then(res=>{
            if(res.data.status === 'success'){
              item.ruleStatus = targetStatus;
              that.$message.success('修改成功');
            }else{
              that.$message.error(res.data.message);
            }
          }).catch(err=>{
            console.error(err);
            that.$message.error('操作失败');
          })
      })
		},
    delSettleRule(id){
		  let that = this;
		  that.$messageBox.confirm('确定要删除此条规则吗?','删除确认',{type: 'warning'}).then(()=>{
		    that.$ajax.post(base.basePath + 'financial/settlement-rule/admin/del/'+id).then(res=>{
		      if(res.data.status === 'success'){
		        $(that.ruleDrawer.rules).each((i,o)=>{
		          if(o.id == id){
		            that.ruleDrawer.rules.splice(i,1);
		            return false;
							}
						})
            that.$message.success('删除成功');
					}else{
		        that.$message.error(res.data.message);
					}
				}).catch(err=>{
				  console.error(err);
				  that.$message.error('删除失败');
				})
			})
		},
    doSettled(){
		  let that = this;
		  if(that.settlementItemDrawer.items.length==0){
        if(!that.settlementItemDialog.form.ruleId){that.$message.warning('请选择结算规则');return}
      }
      if(Number(that.settlementItemDialog.form.settleAmount)<0){that.$message.warning('结算金额不正确');return}
      if(that.settlementItemDialog.form.checkName && $.trim(that.settlementItemDialog.form.doctorRealName).length === 0){
        that.$message.warning('医生姓名不能为空');return
      }
      if($.trim(that.settlementItemDialog.form.remark).length === 0){
        that.$message.warning('备注不能为空');return;
      }

      let ruleId = that.settlementItemDialog.form.ruleId;
      let id = that.settlementItemDrawer.settlement.id;
      let data = {
        settleAmount: that.settlementItemDialog.form.settleAmount*100, //元==>分
        voucher: that.settlementItemDialog.form.voucher,
        checkName: that.settlementItemDialog.form.checkName?1:0,
        doctorRealName: that.settlementItemDialog.form.doctorRealName,
        remark: that.settlementItemDialog.form.remark
      }
      that.settlementItemDialog.btnLoad = true;
      that.$ajax.post(base.basePath + 'financial/settlement-bill/admin/settle/'+id+'?id=' + ruleId,data).then(res=>{
        that.settlementItemDialog.btnLoad = false;
        if(res.data.status === 'success'){
          that.$message.success('结算成功');
          that.settlementItemDialog.show = false;
          // 重新加载列表
          that.handleSettlementItemDrawerOpened();
        }else{
          that.$message.error(res.data.message);
        }
      }).catch(err=>{
        console.error(err);
        that.$message.error('结算失败');
        that.settlementItemDialog.btnLoad = false;
      });
    }
	}
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';
.btn{margin: 0;padding: 0 6px}
.el-icon-setting.rule-setting{
	font-size: 14px;
	font-weight: 900;
	color: #FC7C66;
	cursor: pointer;
	margin-left: 10px;
}
.dialog-footer{
	button{
		padding: 0 20px;
		height: 32px;
		line-height: 32px;
	}
}
.slider-tips{
	width: 10%;
	display: inline-block;
	line-height: 40px;
	height: 40px;
	vertical-align: top;
	margin-left: 20px;
}
span[state]{
	height: 24px;
	line-height: 24px;
	display: inline-block;
	padding: 0 6px;
	cursor: pointer;
}
span[state='0']{color: #FC7C66; background: #FFF2EF;}
span[state='1']{background: rgba(28, 162, 22, 0.1); color: #1CA116;}
</style>